module.exports = __webpack_public_path__ + "img/vertical_4_5_5010.6e2d4dd9.png";